import { FromURL } from "@/features/flow/types";
import { CheckIcon } from "@heroicons/react/24/solid";
import { twMerge } from "tailwind-merge";

export type steps = {
  id: string;
  name: string;
  status: string;
};
type stepperProps = {
  steps: steps[];
  origin: FromURL;
};
export default function Stepper({ steps, origin }: stepperProps) {
  return (
    <nav aria-label="Progress">
      <ol
        role="list"
        className="divide-y divide-gray-300 rounded-md border border-2 border-gray-300 border-slate-50 md:flex md:divide-y-0 dark:border-slate-700"
      >
        {steps.map((step, stepIdx) => (
          <li key={step.name} className="relative md:flex md:flex-1">
            {step.status === "complete" ? (
              <div className="group flex w-full items-center">
                <span className="flex items-center px-2 py-2 font-medium text-sm">
                  <span
                    className={twMerge(
                      "flex size-10 shrink-0 items-center justify-center rounded-full",
                      origin === FromURL.None
                        ? `bg-blue-500 group-hover:bg-blue-700`
                        : "bg-primary group-hover:bg-parimary"
                    )}
                  >
                    <CheckIcon aria-hidden="true" className="size-6 text-white" />
                  </span>
                  <span className="ml-4 font-medium text-gray-900 text-sm dark:text-white">
                    {step.name}
                  </span>
                </span>
              </div>
            ) : step.status === "current" ? (
              <div aria-current="step" className="flex items-center px-2 py-2 font-medium text-sm">
                <span
                  className={twMerge(
                    "flex size-10 shrink-0 items-center justify-center rounded-full border-2 border-primary",
                    origin === FromURL.None && `border-blue-500`
                  )}
                >
                  <span
                    className={twMerge("text-primary", origin === FromURL.None && `text-blue-500`)}
                  >
                    {step.id}
                  </span>
                </span>
                <span
                  className={twMerge(
                    "ml-4 font-medium text-primary text-sm",
                    origin === FromURL.None && "text-blue-500"
                  )}
                >
                  {step.name}
                </span>
              </div>
            ) : (
              <div className="group flex items-center">
                <span className="flex items-center px-2 py-2 font-medium text-sm">
                  <span className="flex size-10 shrink-0 items-center justify-center rounded-full border-2 border-2 border-gray-300 border-slate-50 group-hover:border-gray-400 dark:border-slate-700">
                    <span className="text-gray-500 group-hover:text-gray-900">{step.id}</span>
                  </span>
                  <span className="ml-4 font-medium text-gray-500 text-sm group-hover:text-gray-900">
                    {step.name}
                  </span>
                </span>
              </div>
            )}
            {stepIdx !== steps.length - 1 ? (
              <>
                {/* Arrow separator for lg screens and up */}
                <div
                  aria-hidden="true"
                  className="absolute top-0 right-0 hidden h-full w-5 md:block"
                >
                  <svg
                    fill="none"
                    viewBox="0 0 22 80"
                    preserveAspectRatio="none"
                    className="size-full text-gray-300"
                  >
                    <path
                      d="M0 -2L20 40L0 82"
                      stroke="currentcolor"
                      vectorEffect="non-scaling-stroke"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </>
            ) : null}
          </li>
        ))}
      </ol>
    </nav>
  );
}
